module.exports = __webpack_public_path__ + "static/media/premio-ana-2023.d95f7ea9.webp";